import Header from "@/components/site/Header";
import AnnouncementMarquee from "@/components/site/AnnouncementMarquee";
import HeroSlider from "@/components/site/HeroSlider";
import About from "@/components/site/About";
import Features from "@/components/site/Features";
import Courses from "@/components/site/Courses";
import Amenities from "@/components/site/Amenities";
import Felicitation from "@/components/site/Felicitation";
import SportsDay from "@/components/site/SportsDay";
import MapSection from "@/components/site/MapSection";
import Footer from "@/components/site/Footer";
import EnquiryButton from "@/components/site/EnquiryButton";
import StickyContacts from "@/components/site/StickyContacts";

export default function Home() {
  return (
    <main
      data-testid="home-page"
      className="min-h-screen bg-white text-slate-900"
    >
      <Header />
      <AnnouncementMarquee />
      <HeroSlider />
      <About />
      <Features />
      <Courses />
      <Amenities />
      <Felicitation />
      <SportsDay />
      <MapSection />
      <Footer />
      <EnquiryButton />
      <StickyContacts />
    </main>
  );
}
